import { mainPhone } from "@/lib/site-core";

/**
 * Submit button text and messages for a website form whose Turnstile widget
 * is hidden (appearance "interaction-only", 24 Oct 2026). The widget used to
 * show its own "Verifying…" box; hidden, a Submit button that waits for the
 * token says so itself, and a check that fails says what to do.
 */
export const VERIFYING_LABEL = "Verifying…";

export const VERIFY_FAILED_MESSAGE = `We couldn't verify your browser. Please refresh the page, or call ${mainPhone}.`;

export function submitButtonLabel(opts: {
  token: string | null;
  submitting: boolean;
  label: string;
  submittingLabel: string;
}): string {
  if (opts.submitting) return opts.submittingLabel;
  return opts.token ? opts.label : VERIFYING_LABEL;
}

/** The message under the form: a send error first, then a failed check. */
export function formMessage(
  error: string | null | undefined,
  verifyFailed: boolean,
  token: string | null,
): string | null {
  if (error) return error;
  return verifyFailed && !token ? VERIFY_FAILED_MESSAGE : null;
}
